import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Upload, Text } from "components/fields";
import { Button, Spin2 } from "components";
import { useFormik } from "formik";
import * as Yup from "yup";
import { saveUserGeneralSettings } from "./actions";
import { toastAlert } from "@paylixecommerce/shared/components";
import config from "constants/config";
import getCDNLink from "../../../../constants/cdn-link";
import moment from "moment";

const validationSchema = Yup.object().shape({
	avatar: Yup.array().nullable(),
	vat_percentage: Yup.string(),
	currency: Yup.string().required("Currency is required")
});

const Step1 = ({ settings, setStep, skipStep }) => {

	const [ loading, setLoading ] = useState(false);
	const [ initialValues, setInitialValues ] = useState({
		avatar: [],
		currency: 'USD',
		vat_percentage: '',
		webhook_secret: "",
	});

	useEffect(() => {

		if(Object.keys(settings.shop).length) {

			let { avatar_info, webhook_secret, currency, vat_percentage } = settings.shop;

			let avatar = [];

			if(avatar_info) {
				avatar = [{}];

				if(avatar_info.cloudflare_image_id) {
					avatar[0].preview = getCDNLink({ id: avatar_info.cloudflare_image_id, type: "avatar" })
				}
				if(avatar_info.size) {
					avatar[0].size = avatar_info.size
				}
				if(avatar_info.created_at) {
					avatar[0].date = moment(avatar_info.created_at * 1000).format('DD, MMM YYYY HH:mm')
				}
				if(avatar_info.original_name) {
					avatar[0].name = avatar_info.original_name
				}
			}

			setInitialValues({
				avatar: avatar,
				webhook_secret,
				vat_percentage,
				currency: Object.values(config.CURRENCY_OPTIONS).find(({ key }) => key === currency).key,
			});
		}

	}, [Object.keys(settings.shop).length]);

	const dispatch = useDispatch();

	const onSubmit = (values) => {
		setLoading(true);

		let data = {...values};

		if(data.avatar.length === 0) {
			data.remove_avatar = true;
			delete data.avatar;
		}

		data.currency = typeof data.currency === "string" ? data.currency : data.currency.value;

		dispatch(saveUserGeneralSettings(data))
			.then(setStep)
			.catch(err => {
				toastAlert('error', err ? err.error : "");
			})
			.finally(() => {
				setLoading(false);
			})
	}

	let form = useFormik({
		initialValues: initialValues,
		enableReinitialize: true,
		onSubmit: onSubmit,
		validationSchema
	})

	return (
		<>
			<div className="setup-screen-header">
				<div className="setup-screen-header-title">
					Setup your business on Paylix, starting with the basic features.
				</div>
				<div className="setup-screen-header-subtitle">
					If you are already familiar with our website, you can skip this initial setup.
				</div>
			</div>
			<form onSubmit={form.handleSubmit}>

				<h4>
					General Information
				</h4>

				<Upload name="avatar" {...form} label="Business Logo" />

				<div className="w-100 mb-3">
					<label className="paylixecommerce-label">
						Currency
					</label>

					<select className="paylixecommerce-select" value={form.values.currency} onChange={(e) => form.setFieldValue("currency", e.target.value)}>
						<option value="" disabled hidden>USD...</option>
						{Object.values(config.CURRENCY_OPTIONS).map(({ title, key }) => (
							<option value={key} key={key}>{title}</option>
						))}
					</select>
				</div>


				<div className="position-relative">
					<div className="paylixecommerce-input-prefix">
						%
					</div>
					<Text label="Business VAT percentage" noteUnder note="Configure your business VAT, this percentage will be added to the total cost of your products during the final step of the purchase flow to account for your country's taxes. It will also be used in PDFs and Receipts.
If you have enabled Tax Customization below, this will be the default tax percentage if no country is matched." type="number" step="0.01" name="vat_percentage" placeholder="Vat Percentage" {...form} wrapperClassName="w-100 mr-3" />
				</div>

				<div className="setup-screen-step-buttons">
					<Button variant="secondary" size="large" type="button" onClick={skipStep}>
						Skip Step
					</Button>
					<Button variant="primary" size="large" type="submit">
						{loading ? <Spin2 /> : 'Next Step'}
					</Button>
				</div>
			</form>
		</>
	)
}



export default Step1;
